
<template>
    <div id="listPayment">
        <a v-if="paymentVal != undefined" href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportPayments()">
            Export
        </a>
        <template v-if="paymentVal != undefined">
            <div class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'paymentList'">
                </custom-pagination>
                <vue-good-table
                        mode="remote"
                        title="Reservations"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :isLoading=false
                        :paginationOptions="{
                                                enabled: false,
                                                position: 'both',
                                                perPage: perPage,
                                                perPageDropdown:dropDownPerPage,
                                                dropdownAllowAll: false

                                            }"

                        :search-options="{
                                            enabled: false,
                                            }"
                        :sort-options="{
                                            enabled: true,
                                            }"
                >
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'">
                                <a :key="key" href="javascript:void(0)" class="fp-view" v-on:click="selectAction(props.row.id)" title="View Invoice"></a>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                </vue-good-table>
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                </custom-pagination>
            </div>
        </template>
        <template v-if="paymentVal == undefined">
            <div :class="`loader${loaderClass}`" v-show="loading"></div>
            <div id="page-content-wrapper" class="admin-content-area">
                <template v-if="cantAccessPage === true">
                    <div class="page-name">
                        <div class="page-title"> Payment List</div>
                    </div>
                    <div class="container-fluid">
                        <div class="admin-page-content payment-lists">
                            <div class="payment-filter-section">
                                <data-table-filter-config :moduleName="'paymentList'" @cancelSelection="cancelAll"></data-table-filter-config>
                            </div>
                            <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'paymentList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        mode="remote"
                                        ref="paymentListTable"
                                        title="Reservations"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :isLoading=false
                                        :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false

                                    }"

                                        :search-options="{
                                    enabled: false,
                                    }"
                                        :sort-options="{
                                    enabled: true,
                                    }"
                                >
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <a :key="key" href="javascript:void(0)" class="fp-view" v-on:click="selectAction(props.row.id)" title="View Invoice"></a>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                        </div>
                    </div>
                </template>
                <template v-else-if="cantAccessPage === false">
                    <div class="container-fluid">
                        <div class="bg-white text-center">
                            <h1>
                                Oops!</h1>
                            <h2>
                                403 </h2>
                            <div class="error-details">
                                Sorry!, You don't have permission to access this page.
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <loading-content></loading-content>
                </template>
                <app-footer></app-footer>
            </div>
        </template>
        <div class="modal fade invoice-modal" id="mapper_modal" ref="preAuthAmount" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Make Payment</h5>
                    </div>
                    <div class="modal-body">
                        <form class="addinspectionForm map-form-rt">
                            <div class="form-row row-cols-md-2 row-cols-1"></div>
                                <div class="col form-group">
                                    <label class="control-label">Customer:</label>
                                    <v-select v-model="customer" name="checkUser"
                                              label="text" :filterable="false" :options="customerArr"
                                              @search="onSearch"
                                              placeholder="Select Customer" @input="selectCustomer">
                                        <template slot="no-options">
                                            Search Customers...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{customer_error}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label">Invoices:</label>
                                    <v-select v-model="invoices" name="checkInvoices"
                                              label="text" multiple :options="invoiceArr"
                                              placeholder="Select Invoice" >

                                    </v-select>
                                </div>
                                <div class="col form-group" v-if="outstanding != ''">
                                    <label class="control-label">Outstanding Amount:</label>
                                    <span class="label">$ &nbsp;{{outstanding}}</span>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label">Amount To Pay:</label>
                                    <input type="text" class="form-control" placeholder="Enter Amount" v-model="amounttopay">
                                    <div class="field-error">{{pay_error}}</div>
                                </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="makePaymentBtn" class="btn btn-primary" v-on:click="makePayment()">Pay</button>
                        <button id="paymentCancelBtn" type="button" class="btn btn-tertiary" v-on:click="customerArr = [], customer = '' , outstanding = '' , amounttopay = ''"  data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import EventBus from ".././event-bus";

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    var contex
    export default {
        name: "listPayment",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Payment List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            paymentVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            userRole:"",
            invoiceArr:[],
            invoices:[],
            permissions: [],
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    html: true,
                    sortable: false,

                },
                {
                    label: "Customer",
                    field: "contact",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterTypes: ['contains','doesn`contains','starts with','ends with','is null','is not null'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Sync Status",
                    field: "sync_status",
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['True','False'],
                        filterTypes: ['is','is not'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Payment Identifier",
                    field: "payment_identifier",
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Rental',"Enrich"],
                        filterTypes: ['is','is not'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "#Credit Card",
                    field: "credit_card_no",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Credit Card No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        filterTypes: ['contains','doesn`contains','starts with','ends with','is null','is not null'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "#Payment",
                    field: "tx_ref_num",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Payment Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterTypes: ['contains','doesn`contains','starts with','ends with','is null','is not null'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Payment Option",
                    field: "payment_options",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Payment Option", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterTypes: ['contains','doesn`contains','starts with','ends with','is null','is not null'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "Amount",
                    field: "amount",
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterTypes: ['contains','doesn`contains','starts with','ends with','is null','is not null'],
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Payment Date',
                    field: 'payment_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
            ],
            rows: [],
            totalRecords: 0,
            cancel_booking_id: 0,
            cancelvalue: "",
            amounttopay:"",
            outstanding:"",
            customer:"",
            customerArr : [],
            customer_error:"",
            pay_error:"",
            cantAccessPage:"",
            loading:false,
            flag:"",
            canPay:false,
        }),
        watch: {

            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_payment') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'make_payment') {
                        self.canPay = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },
            //get customer invoices
            customer: function(cust){
                var self = this;
                self.getInvoices(cust.value);
            },

            //change amount to pay on select invoice
            invoices: function (inv) {

                var oldInv = inv;
                var tempArr = {};

                if ( inv.length == 0 ) {
                    return;
                }

                //check duplicate
                for( var i=0; i<oldInv.length; i++ ) {
                    var checkval = oldInv[i].value;

                    if ( tempArr[checkval] === undefined ) {
                        tempArr[checkval] = 1;
                    } else {
                        tempArr[checkval] = tempArr[checkval] + 1;
                    }
                }

                this.amounttopay = 0;
                for( var i=0;i<inv.length;i++) {

                    //check duplicate in temp array
                    if ( tempArr[inv[i].value] > 1 ) {
                        this.invoices.splice(i,1);
                    } else {
                        this.amounttopay += inv[i].amount;
                    }

                }
                this.amounttopay = this.amounttopay.toFixed(2)
            },

            //unselect invoices if invoice amount total and amount to pay is not equal
            amounttopay: function (amount) {

                var invoiceAmount = 0;
                for( var i=0;i<this.invoices.length;i++) {
                    invoiceAmount += this.invoices[i].amount;
                }
                if ( amount != invoiceAmount ) {
                    this.invoices = [];
                }
                console.log(this.invoices);
            }


        },

        mounted: function() {

            var self = this;
            this.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.paymentListTable.unselectAllInternal();
            },


            getInvoices: function(id){

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/search/invoices",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data:{
                        customer_id:id
                    },

                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            self.invoiceArr = data.content;
                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'search-invoice');
                    }
                });

            },
            //when select customer in make payment mddal
            selectCustomer(event) {
                var self = this;

                if ( event != "" ) {
                    // alert('hello');

                    self.outstanding = self.numberFormat(event.outstanding);
                    self.amounttopay = self.numberFormat(event.outstanding);
                } else {
                    self.outstanding = "";
                    self.amounttopay = "";
                }

            },
            // selectInvoices
            openPaymentModal: function(){

                var self = this;

                self.payments ="",
                    self.reservations = "",
                    self.pay_error = "";
                self.customer_error = "";
                $("#mapper_modal").modal('show');

            },
            onSearch(search, loading)
            {
                if (search.length > 1) {
                    loading(true);
                    this.checkCustomer(loading, search, this);
                }
            },
            onSearchReservation(search, loading)
            {
                if (search.length > 1) {
                    loading(true);
                    this.getReservationDetails(loading, search, this);
                }
            },
            selectAction: function(id) {
                var self = this;
                if(self.paymentVal == 'unsyncpayment'){
                    self.flag = 'unsyncpayment';
                } else {
                    self.flag = 'paymentlist';
                }
                self.$router.push("/invoice/list?paymentId="+id+"&flag="+self.flag);
                //self.$router.push({name:'ViewInvoices',params:{id:id , flag:self.flag}});
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                var self = this;
                self.updateParams({page: params.currentPage});

                self.loadList();
            },

            onPerPageChange(params) {
                var self = this;
                self.updateParams({perPage: params.currentPerPage});
                this.serverParams.page = 1 ;
                // this.totalRecords = self.totalRecords;
                self.loadList();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },

                });
                this.loadList();
            },

            onColumnFilter(params) {
                var self = this;
                self.updateParams(params);

                {field: ('reference_no'); field: ('company'); field: ('contact');
                    field: ('location'); field: ('unit_no');
                    field: ('status'); field: ('created_at'); field: ('updated_at'); field: ('transaction_no');}


                self.serverParams.page = 1 ;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.reference_no || filters.company || filters.contact || filters.location
                    || filters.unit_no || filters.status || filters.created_at || filters.updated_at || filters.transaction_no ) {
                    this.loadList();
                }


            },*/

            // loadReservations is what brings back the rows from server
            loadList: function() {

                var self = this;

                if(self.paymentVal == 'unsyncpayment'){
                    self.flag = 'unsyncpayment';
                }
                self.loading = true;
                var date = new Date();
                var offset = date.getTimezoneOffset();

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/payment/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{ page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: this.serverParams.sort,
                        offset:offset,
                        flag:self.flag},
                    success: function(data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            if(data.content.row != undefined) {
                                self.rows = data.content.row;
                            }
                            //if list page load for the unsync customer
                            // if(self.paymentVal == 'unsyncpayment'){
                            //     EventBus.$emit("unSyncCustomerCnt", data.content.customerCnt);
                            //     EventBus.$emit("unSyncPaymentCnt", data.content.totalRecords);
                            //     EventBus.$emit("unSyncReservationCnt", data.content.reservationCnt);
                            // }
                            //self.perPage = data.content.perPage;
                            if(data.content.totalRecords == 0){
                                self.rows = [];
                            }
                            self.totalRecords = data.content.totalRecords;

                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'payment-list');
                    }
                });


            },
            checkCustomer: function (loading, search) {
                var self = this;
                // self.loading = true;
                //self.CheckBtn = "Checking ...";
                // $("#registerForm").trigger("reset");
                $.ajax({
                    url: process.env.ROOT_API + "/search",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        search: search,
                        flag:"customer"
                    },
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            loading(false);
                            self.customerArr = data.content;


                        } else if (data.status == "error") {
                            self.loading = false;
                            self.error_msg = data.message;
                            self.msgClass = "error";
                            self.msg = false;
                            $("#regformhide").show();
                            self.orIcon = true;
                            $("#regbtn").show();
                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'check-customer');
                    }
                });

            },
            makePayment: function(){

                var self = this;
                self.pay_error = '';
                self.customer_error = '';
                if(self.customer == null){
                    self.customer_error = 'Customer Field Required';
                }
                if(self.customer == ''){
                    self.customer_error = 'Customer Field Required';
                }
                if(self.invoices != null){
                    self.inv_error = 'Invoice Field Required';
                }
                if(self.invoices != ''){
                    self.inv_error = 'Invoice Field Required';
                }
                if(!self.amounttopay){
                    self.pay_error = 'Amount Required';
                }
                if(self.amounttopay < 1 ){
                    self.pay_error = 'Amount can not be less than 1.';
                }

                if(self.pay_error != '' || self.customer_error != ''){
                    return;
                }


                //get invoice number as string
                var invString = "";
                if ( self.invoices.length > 0 ) {
                    for( var i=0;i<self.invoices.length;i++ ){

                        if ( invString == "" ) {
                            invString = self.invoices[i].value;
                        } else {
                            invString +=","+self.invoices[i].value;
                        }
                    }
                }

                //invoices:self.invoices,
                $("#makePaymentBtn").text("Processing...");
                $("#makePaymentBtn").prop("disabled", true);
                $("#paymentCancelBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.RENTAL_API + process.env.VERSION +"/process_payment",
                    crossDomain: true,
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        paymentMethod:'credit_card',
                        amount:self.amounttopay,
                        customer_id:self.customer.value,
                        flag:'paymentlist'
                    },
                    success: function (data) {

                        self.loading = false;
                        $("#makePaymentBtn").text("Pay");
                        $("#makePaymentBtn").prop("disabled", false);
                        $("#paymentCancelBtn").prop("disabled", false);


                        if (data.status == "success") {
                            var uId = data.content.uId.split( '=' );

                            var rentalUrl = process.env.RENTAL_URL+'payment?';
                            rentalUrl += "secret="+localStorage.getItem("tkn");
                            rentalUrl += "&uId="+uId[1];
                            rentalUrl += "&sessionId="+data.content.sessionId;
                            rentalUrl += "&bookingRef="+data.content.bookingRef;
                            rentalUrl += "&redirectFlag="+data.content.flag;
                            rentalUrl += "&invoices="+invString;
                            //alert(rentalUrl);
//                            localStorage.setItem("uId",uId[1]);
//                            localStorage.setItem("sessionId",data.content.sessionId);
//                            localStorage.setItem("bookingRef",data.content.bookingRef);

                            self.customerArr = [];
                            self.customer = '';
                            self.outstanding = '';
                            self.amounttopay = '';

                            $("#mapper_modal").modal('hide');
                            window.open(rentalUrl,'_blank');


                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#makePaymentBtn").text("Pay");
                        $("#makePaymentBtn").prop("disabled", true);
                        $("#paymentCancelBtn").prop("disabled", false);

                        self.generateStatusCodeMessage(jqXHR,true,'process-payment');
                    }
                });

            },
            numberFormat(amount) {
                return parseFloat(amount).toFixed(2);
            },
            exportPayments: function(){
                var self = this;

                var date = new Date();
                var offset = date.getTimezoneOffset();
                 $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/payment/list",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        offset:offset,
                        sort: this.serverParams.sort,
                        flag:'export_payment'
                    },
                    success: function(data) {
                        self.loading = false;
                        console.log(data);
                        self.excel = data.content.web;
                        // var filename = data.content.filename;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        // save.setAttribute('download', 'Reservation');
                        save.download = self.excel;
                        save.target = "_blank";
                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    // $("#invoice_modal .modal-body").html(data);
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'export-payment');
                    }
                });
            }
        }
    };
</script>
<style scoped>
    /*#tableFlow{*/
    /*overflow-y: auto;*/
    /*}*/
</style>




// WEBPACK FOOTER //
// src/components/payment/PaymentList.vue